import { selectRecipient } from "@/store/chat";
import { RootState } from "@/store/reducers";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Recipient from "./Recipient";
import { RouteConstant } from "@/routes/routeConstant";
import { FriendList } from "./FriendList";
import { useGetRecipientsMutation } from "@/services/modules/chat";

export const RecipientList = () => {
  const allRecipients = useSelector(
    (state: RootState) => state.chat.recipients
  );
  const dispatch = useDispatch();
  const { recipientId } = useParams<{ recipientId?: string }>();
  const navigate = useNavigate();
  const [getRecipients] = useGetRecipientsMutation();

  useEffect(() => {
    getRecipients();
  }, []);

  useEffect(() => {
    if (allRecipients && recipientId) {
      const recipient = allRecipients.find(
        (c) => c.userId == parseInt(recipientId)
      );
      if (recipient) {
        dispatch(selectRecipient(recipient));
        navigate(RouteConstant.Posts);
      }
    }
  }, [allRecipients, recipientId]);

  return (
    <FriendList
      friendList={allRecipients}
      Item={({ item }) => <Recipient recipient={item} />}
    />
  );
};
